export const TriageWorkflowTaskInputs = {
  CodingSystem: 'urn:inav:triage:workflow',
  StepSequenceCode: 'step-sequence',
  JourneyRevisionCode: 'journey-revision',
  QuestionnaireEventSequenceCode: 'questionnaire-event-sequence',
} as const;
